import actionTypes from '../constants/action-types';

const setPageContainerSelector = (pageContainer) => ({
  type: actionTypes.SET_PAGE_CONTAINER_SELECTOR,
  payload: {
    pageContainer,
  },
});

export default setPageContainerSelector;
